import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../services/redux/types";
import { DRAWIO_INITIAL_EMBED_URI, INITIAL_XML } from "../constants";

export const selectSchemasState = (state: RootState) => state.schemasState;

export const selectSchemaValue = createSelector(
  selectSchemasState,
  (state) => state.schemaValue,
);

export const selectSchema = createSelector(selectSchemaValue, (schema) =>
  schema ? schema.schemas_object.schema_xml : INITIAL_XML,
);

export const selectSchemasThreadRef = createSelector(
  selectSchemaValue,
  (value) => {
    return value?.metadata ? value.metadata?.thread_ref : null;
  },
);

export const selectSchemasChatMode = createSelector(
  selectSchemaValue,
  (value) => {
    return value?.metadata ? value.metadata?.mode : null;
  },
);

export const selectSchemasMessages = createSelector(
  selectSchemasState,
  (state) => state.messages,
);

export const selectMessagesBySchemaId = createSelector(
  selectSchemasMessages,
  (_: RootState, id: string | null) => id,
  (messages, id) => (id ? (messages[id] ?? []) : []),
);

export const selectTemporarySchema = createSelector(
  selectSchemasState,
  (state) => state.temporaryScheme,
);

export const selectSchemaTimer = createSelector(
  selectSchemasState,
  (state) => state.timer,
);

export const selectSchemasIsMessageLoading = createSelector(
  selectSchemasState,
  (state) => state.isMessageLoading,
);

export const selectIsMessageLoadingById = createSelector(
  selectSchemasIsMessageLoading,
  (_: RootState, id: string | null) => id,
  (isMessageLoading, id) => (id ? (isMessageLoading[id] ?? null) : null),
);

export const selectSchemaTimerById = createSelector(
  selectSchemaTimer,
  (_: RootState, id: string | null) => id,
  (timer, id) => (id ? (timer[id] ?? null) : null),
);

export const selectSchemasIsFileLoading = createSelector(
  selectSchemasState,
  (state) => state.isFileLoading,
);

export const selectDrawIoUri = createSelector(selectSchemaValue, (schema) =>
  schema ? schema.schemas_object.schema_url : DRAWIO_INITIAL_EMBED_URI,
);

export const selectHasUnsavedChanges = createSelector(
  selectSchemasState,
  (state) => state.hasUnsavedChanges,
);

export const selectRefreshToken = createSelector(
  selectSchemasState,
  (state) => state.refreshToken,
);
